import { normalizeClass as _normalizeClass, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {
      class: _normalizeClass({'is-invalid': _ctx.computedErrors.length > 0})
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedErrors, (error) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.validationErrorText(error)), 1))
    }), 256))
  ]))
}